import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Card, Grid} from 'semantic-ui-react';
import {reduxForm, Field, formValueSelector, change} from 'redux-form';
import {DropdownField, DatePickerField, TextAreaField} from '../../../common/components/form';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {QUALITY_ASSURANCE_ORDERS_FORM} from '../../../common/forms';
import {Actions} from '../../../common/actions';

const inspectionOptions = [{'text': 'Si', 'value': 'yes'}, {'text': 'No', 'value': 'no'}];

class QualityControlOrderForm extends Component {
  constructor(props) {
    super(props);
    this.changeWorkStartDate = this.changeWorkStartDate.bind(this);
  }

  changeWorkStartDate(value) {
    const {deliveryDate} = this.props;
    const startDateFormatted = moment(value).format(noTimeZoneShortISODate);
    if (deliveryDate && moment(value) > moment(deliveryDate)) {
      this.props.change('deliveryDate', startDateFormatted);
    }
  }

  getDealersOptions() {
    const {dealersList} = this.props;
    return dealersList.map((item) => {
      return {'value': item.identification, 'text': item.name};
    });
  }

  getTechniciansOptions() {
    const {techniciansList} = this.props;
    return techniciansList.map((item) => {
      return {'value': item.technician, 'text': `${item.technician}-${item.name}`};
    });
  }

  renderTitle(width, label) {
    return (
      <Grid.Column width={width}>
        <h4>{label}</h4>
      </Grid.Column>
    );
  }

  render() {
    const {loadingTechnicians, loadingDealers, requiresInspection, workStartDate, chassis} = this.props;
    return (
      <Card raised fluid className='quality-assurance-orders-data'>
        <Grid textAlign='left'>
          <Grid.Row>
            {this.renderTitle(1, 'Facturar a:')}
            <Grid.Column width={3}>
              <Field
                name='billClient'
                options={this.getDealersOptions()}
                component={DropdownField}
                loading={loadingDealers}
                placeholder='Seleccione el Cliente'
                disabled={!chassis}
                required
              />
            </Grid.Column>
            {this.renderTitle(2, 'Requiere Inspección del Vehículo:')}
            <Grid.Column width={2}>
              <Field
                name='requiresInspection'
                options={inspectionOptions}
                component={DropdownField}
                placeholder='Seleccione una opción'
                disabled={!chassis}
                required
              />
            </Grid.Column>
            {requiresInspection === 'yes' &&
            this.renderTitle(1, 'Responsable:')}
            {requiresInspection === 'yes' &&
            <Grid.Column width={3}>
              <Field
                name='responsible'
                options={this.getTechniciansOptions()}
                component={DropdownField}
                loading={loadingTechnicians}
                disabled={!chassis}
                required={requiresInspection === 'yes'}
                placeholder='Seleccione el Responsable'
              />
            </Grid.Column>
            }
          </Grid.Row>

          <Grid.Row>
            {this.renderTitle(2, 'Fecha Inicio de Trabajo:')}
            <Grid.Column width={2}>
              <Field name='workStartDate'
                component={DatePickerField}
                required
                validate={this.checkRequiredField}
                placeholder='Seleccione una fecha'
                onChange={this.changeWorkStartDate}
                disabled={!chassis}
              />
            </Grid.Column>
            {this.renderTitle(2, 'Fecha Entrega:')}
            <Grid.Column width={2}>
              <Field name='deliveryDate'
                component={DatePickerField}
                required
                validate={this.checkRequiredField}
                placeholder='Seleccione una fecha'
                minDate={workStartDate}
                disabled={!chassis || !workStartDate}
              />
            </Grid.Column>
            {this.renderTitle(2, 'Observaciones:')}
            <Grid.Column width={6}>
              <Field
                name='observations'
                component={TextAreaField}
                autoheight
                disabled={!chassis}
                normalize={(value) => {
                  return value.toUpperCase();
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
  
  checkRequiredField(value) {
    return value ? null : 'Required';
  }
}

export {QualityControlOrderForm};

const form = reduxForm({
  'form': QUALITY_ASSURANCE_ORDERS_FORM.name,
})(QualityControlOrderForm);

const mapStateToProps = (state) => {
  const selector = formValueSelector(QUALITY_ASSURANCE_ORDERS_FORM.name);
  const requiresInspection = selector(state, 'requiresInspection');
  const workStartDate = selector(state, 'workStartDate');
  const deliveryDate = selector(state, 'deliveryDate');

  return {
    'loadingTechnicians': state.techniciansAssignment.loading,
    'techniciansList': state.techniciansAssignment.list,
    'loadingDealers': state.dealer.loading,
    'dealersList': state.dealer.list,
    requiresInspection,
    workStartDate,
    deliveryDate,
  };
};

const {
  clearPrioritizationIndices,
} = Actions;

export default connect(mapStateToProps, {
  clearPrioritizationIndices,
  change,
})(form);
